import React from 'react';

type BlogMetaProps = {
  author: string;
  publishedAt: string;
  readTime: string;
  tags?: string[];
};

function BlogMeta({ author, publishedAt, readTime, tags = [] }: BlogMetaProps) {
  return (
    <div className="blog-meta" aria-label="Post metadata">
      <span>{author}</span>
      <span>{publishedAt}</span>
      <span>{readTime}</span>
      {tags.length > 0 ? <span>{tags.join(' · ')}</span> : null}
    </div>
  );
}

export default BlogMeta;
